export default __webpack_public_path__ + "static/media/Wall_Window_8x4_03.256.413a12d6.png";